import axios from "axios";
import { getAnonId } from "@/lib/anonId";

// Prefer same-origin in the browser (works on any custom domain + emergent
// host + preview) — eliminates CORS issues when the app is served from a
// different host than the one baked at build time (e.g. recomendalibros.com).
// Falls back to REACT_APP_BACKEND_URL for local dev / SSR.
const sameOrigin = (
    typeof window !== "undefined"
    && window.location
    && !window.location.hostname.includes("localhost")
    && !window.location.hostname.startsWith("127.")
);
const BACKEND_URL = sameOrigin
    ? window.location.origin
    : (process.env.REACT_APP_BACKEND_URL || "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Always attach an anonymous identity header so feedback/read/history can
// attribute actions even before the user logs in.
api.interceptors.request.use((config) => {
    try {
        const anon = getAnonId();
        if (anon) {
            config.headers = config.headers || {};
            config.headers["X-Anon-Id"] = anon;
        }
    } catch {
        /* ignore */
    }
    return config;
});

export default api;

export function formatApiError(detail) {
    if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
